import React from 'react';
import dayjs from 'dayjs';

import Badge from '@mui/material/Badge';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

export function CalendarDayBadge(props) {
  const {
    day,
    outsideCurrentMonth,
    highlightedDays = [],
    onDayDoubleClick,
    selectedDate,
    ...other
  } = props;
  const showBadge = !outsideCurrentMonth && highlightedDays.includes(day.date());
  const selectedWeekStart = dayjs(selectedDate).startOf('day').subtract((dayjs(selectedDate).day() + 6) % 7, 'day');
  const selectedWeekEnd = selectedWeekStart.add(6, 'day');
  const isInSelectedWorkWeek =
    selectedDate &&
    (day.isSame(selectedWeekStart, 'day') ||
      day.isSame(selectedWeekEnd, 'day') ||
      (day.isAfter(selectedWeekStart, 'day') && day.isBefore(selectedWeekEnd, 'day')));
  const className = [other.className, isInSelectedWorkWeek ? 'selected-week-day' : ''].filter(Boolean).join(' ');

  return (
    <Badge overlap="circular" variant={showBadge ? 'dot' : 'standard'} badgeContent={undefined}>
      <PickersDay
        {...other}
        className={className}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        onDoubleClick={() => onDayDoubleClick?.(day)}
      />
    </Badge>
  );
}
